export default __webpack_public_path__ + "static/media/iconfont.ea6bc242.eot";